import { render, staticRenderFns } from "./ArrowupIcon.vue?vue&type=template&id=c7a847ac&scoped=true"
var script = {}
import style0 from "./ArrowupIcon.vue?vue&type=style&index=0&id=c7a847ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a847ac",
  null
  
)

export default component.exports